import type { SettingsSubComponentProps } from '@carboncopyco/components';
import {
  SettingMainItemsKeys,
  SettingsSubKeys,
} from '@carboncopyco/types/desktop/appSettings';
import { Slider, TextBase, Toggle } from '@carboncopyco/ui';
import { useBoolean } from 'ahooks';
import { useState } from 'react';
import { ColorList } from './ColorList';
import { HeaderBlock } from './HeaderBlock';

const MouseAnimation = ({ saveData, getValue }: SettingsSubComponentProps) => {
  const [color, setColor] = useState(
    getValue(SettingsSubKeys.MouseAnimationColor)
  );
  const [isActive, { toggle: toggleActive }] = useBoolean(
    getValue(SettingsSubKeys.MouseAnimationToggleState)
  );
  const [size, setSize] = useState(
    getValue(SettingsSubKeys.MouseAnimationSize)
  );
  const [time, setTime] = useState(
    getValue(SettingsSubKeys.MouseAnimationSpeed)
  );
  return (
    <div className="flex flex-col grow">
      <HeaderBlock
        label={SettingMainItemsKeys.MouseAnimation}
        description="Improve the demo experience with a mouse that pulses every time you click."
      />
      <div className="flex-col flex pr-7">
        <div className="flex-col flex gap-7 -mr-7">
          <Slider
            min={15}
            max={60}
            defaultValue={size}
            onChange={(v) => {
              saveData(SettingsSubKeys.MouseAnimationSize, v[0], setSize);
            }}
            valueDescription="px"
            title="Set cursor highlight animation size"
          />
          <Slider
            min={-600}
            max={-200}
            step={50}
            showValueOnThumb={false}
            showMinMax
            minLabel="Slow"
            maxLabel="Fast"
            defaultValue={time}
            onChange={(t) => {
              saveData(SettingsSubKeys.MouseAnimationSpeed, t[0], setTime);
            }}
            title="Set cursor animation display time"
          />
        </div>
        <div className="pt-10">
          <TextBase
            label="Set highlight color"
            color="text-ds-natural-600"
          />
        </div>
        <div className="flex pt-2.5 ">
          <ColorList
            colors={[
              '#0078EF',
              '#FFF500',
              '#37363F',
              '#FF833D',
              '#38D695',
              '#9B9AA2',
              '#0000FF',
              '#5F5E65',
              '#F1F1F3',
            ]}
            selectedColor={color}
            onChange={(selectedColor) =>
              saveData(
                SettingsSubKeys.MouseAnimationColor,
                selectedColor,
                setColor
              )
            }
          />
        </div>
        <div className="flex w-full items-center justify-between pt-7">
          <div>
            <TextBase
              label="Set mouse animation as default"
              color="text-ds-natural-600"
            />
          </div>
          <div>
            <Toggle
              testId="mouseAnimationToggle"
              checked={isActive}
              onChange={() => {
                saveData(
                  SettingsSubKeys.MouseAnimationToggleState,
                  !isActive,
                  toggleActive
                );
              }}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default MouseAnimation;
